export default "__VITE_ASSET__DRCWggeM__"